import { action_getCachedRegionByCountryCode } from "src/components/(checkout)/cart/actions"
import { setCartRegion } from "src/components/(checkout)/cart/api"
import { getCart, queueCartUpdate, useCart } from "src/components/(checkout)/cart/state"
import { useCountries } from "src/components/common/useCountries"
import { AppCountryCode, DEFAULT_COUNTRY_CODE } from "src/localization/localization"
import { recordError } from "src/utilities/errorReporting"
import { createPersistentStore } from "src/utilities/localStorage/create"

type State = {
  countryCode: AppCountryCode
}

const defaultState: State = {
  countryCode: DEFAULT_COUNTRY_CODE,
}

const store = createPersistentStore(() => defaultState, {
  name: "country",
  persistInitialState: true,
})

export function getPreferredCountryCode() {
  return store.getState().countryCode
}

export function useCountryCode(): AppCountryCode {
  const cartCountryCode = useCart()?.shipping_address?.country_code as AppCountryCode
  const preferredCountryCode = store((state) => state.countryCode)

  return cartCountryCode || preferredCountryCode
}

export function useCountry() {
  const countries = useCountries()
  const countryCode = useCountryCode()

  return countries.data.find((country) => country.code === countryCode)
}

export async function setCountryCode(countryCode: AppCountryCode) {
  store.setState({ countryCode })

  const cart = getCart()
  const cartCountryCode = cart?.shipping_address?.country_code

  if (!cart || !cartCountryCode) {
    return
  }

  if (cartCountryCode !== countryCode) {
    const region = await action_getCachedRegionByCountryCode(countryCode)

    if (!region) {
      recordError(`Failed to find region for country code: ${countryCode}`)
      return
    }

    if (cart.region_id !== region.id) {
      await queueCartUpdate((cart) => setCartRegion({ cart, region, countryCode }))
    }
  }
}
